import React from 'react';
import { ReactComponent as IconInstagram } from '../../assets/icons/icon_instagram.svg';
import { ReactComponent as IconTwitter } from '../../assets/icons/icon_twitter.svg';
import { ReactComponent as IconFacebook } from '../../assets/icons/icon_facebook.svg';
import { ReactComponent as IconWebsite } from '../../assets/icons/icon_website.svg';

interface IProps {
    className?: string,
    instagram?: string,
    twitter?: string,
    facebook?: string,
    website?: string
}

const SocialMediaIcons: React.FC<IProps> = ({ className, instagram, twitter, facebook, website }) => {
    return (
        <div className={`social-media-icons ${className}`}>
            {
                instagram &&
                <a href={instagram} target="_blank" rel="noopener noreferrer">
                    <IconInstagram />
                </a>
            }
            
            {
                twitter &&
                <a href={twitter} target="_blank" rel="noopener noreferrer">
                    <IconTwitter />
                </a>
            }

            {
                facebook &&
                <a href={facebook} target="_blank" rel="noopener noreferrer">
                    <IconFacebook />
                </a>
            }

            {
                website &&
                <a href={website} target="_blank" rel="noopener noreferrer">
                    <IconWebsite />
                </a>
            }
        </div>
    )
}

export default SocialMediaIcons;
